import React, { useState, useEffect } from "react";
import { fetchCars, fetchContent } from "../api";
import CarCard from "../components/CarCard";
import PageBanner from "../components/PageBanner";
import ComingSoonSection from "../components/ComingSoonSection";
import { Search } from "lucide-react";

const MOTO_BANNER = "https://images.unsplash.com/photo-1568708167253-8a8dca6b2970?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxjYWZlJTIwcmFjZXJ8ZW58MHx8fHwxNzg2NjAyNjA4fDA&ixlib=rb-4.1.0&q=85";

const Motorcycles = () => {
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("default");
  const [bikes, setBikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [comingSoon, setComingSoon] = useState(null);

  useEffect(() => { fetchContent("comingSoon").then(setComingSoon).catch(() => setComingSoon(null)); }, []);

  useEffect(() => {
    setLoading(true);
    const params = { sort, vehicleType: "motorcycle" };
    if (query) params.q = query;
    const t = setTimeout(() => {
      fetchCars(params)
        .then((data) => setBikes(data.filter((c) => c.status !== "sold")))
        .catch(() => setBikes([]))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [query, sort]);

  return (
    <div className="bg-white">
      <PageBanner
        title="Motorcycles For Sale"
        subtitle="Classic and modern-classic motorcycles, hand-picked for the discerning rider."
        image={MOTO_BANNER}
      />
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between mb-10">
          <div className="relative w-full md:w-80">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search motorcycles..."
              className="w-full pl-10 pr-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm"
            />
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500">{bikes.length} motorcycles</span>
            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              className="border border-black/15 py-3 px-4 text-sm outline-none focus:border-[var(--gpm-green)] bg-white"
            >
              <option value="default">Sort: Featured</option>
              <option value="low">Price: Low to High</option>
              <option value="high">Price: High to Low</option>
              <option value="year">Newest Year</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-24 text-gray-500">Loading motorcycles…</div>
        ) : bikes.length === 0 ? (
          <div className="text-center py-24 text-gray-500">No motorcycles match your search.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {bikes.map((c) => (
              <CarCard key={c.id} car={c} />
            ))}
          </div>
        )}
      </div>

      <ComingSoonSection data={comingSoon?.motorcycles} />
    </div>
  );
};

export default Motorcycles;
